import '@fontsource-variable/manrope';
import '@fontsource-variable/archivo';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';
import { Seo } from './components/Seo';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { GuideDetail } from './pages/GuideDetail';
import { Guides } from './pages/Guides';
import { Home } from './pages/Home';
import { NotFound } from './pages/NotFound';
import { Privacy } from './pages/Privacy';
import { Projects } from './pages/Projects';
import { ServiceArea } from './pages/ServiceArea';
import { ServiceDetail } from './pages/ServiceDetail';
import { Services } from './pages/Services';
import './designs/heritage-ledger/theme.css';
import './styles/base.css';
import './styles/components.css';

export function App() {
  return (
    <>
      <Seo />
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="services" element={<Services />} />
          <Route path="brick-repair-repointing" element={<ServiceDetail />} />
          <Route path="brick-block-masonry" element={<ServiceDetail />} />
          <Route path="indoor-outdoor-tile-installation" element={<ServiceDetail />} />
          <Route path="concrete-driveways-patios" element={<ServiceDetail />} />
          <Route path="paver-driveways-hardscapes" element={<ServiceDetail />} />
          <Route path="retaining-walls-drainage" element={<ServiceDetail />} />
          <Route path="driveway-culverts-headwalls" element={<ServiceDetail />} />
          <Route path="stone-veneer" element={<ServiceDetail />} />
          <Route path="chimney-masonry-repair" element={<ServiceDetail />} />
          <Route path="projects" element={<Projects />} />
          <Route path="service-area" element={<ServiceArea />} />
          <Route path="about" element={<About />} />
          <Route path="guides" element={<Guides />} />
          <Route path="guides/:guideSlug" element={<GuideDetail />} />
          <Route path="contact" element={<Contact />} />
          <Route path="privacy" element={<Privacy />} />
          <Route path="not-found" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}
